<template>
  <div class=" content-page ">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('mian-ze-sheng-ming') }} </div>


    <div class="disclaimer-content" v-html="content"></div>

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
      content: `
        <div class="disclaimer-section">
          <h2>Disclaimer</h2>
          <p class="last-updated">Last Updated: ${new Date().toISOString().split('T')[0]}</p>
          
          <div class="disclaimer-item">
            <h3>1. General Disclaimer</h3>
            <p>The information provided on this platform is for general informational purposes only. All information on the platform is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the platform.</p>
            <p>Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the platform or reliance on any information provided on the platform. Your use of the platform and your reliance on any information on the platform is solely at your own risk.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>2. Investment Risks</h3>
            <p>Trading digital assets involves significant risk and can result in the loss of your invested capital. You should not invest more than you can afford to lose.</p>
            <p>The values of digital assets are highly volatile and can fluctuate significantly in a short period of time. Past performance is not indicative of future results. Before making any investment decisions, you should carefully consider your investment objectives, level of experience, and risk appetite.</p>
            <p>We strongly recommend seeking advice from an independent financial advisor if you have any doubts.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>3. No Investment Advice</h3>
            <p>The content on this platform does not constitute investment advice, financial advice, trading advice, or any other sort of advice, and you should not treat any of the platform's content as such.</p>
            <p>We do not recommend that any cryptocurrency should be bought, sold, or held by you. Conduct your own due diligence and consult your financial advisor before making any investment decisions.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>4. Market Information</h3>
            <p>Any market data, price feeds, or other information displayed on this platform is provided as general market commentary and does not constitute investment advice. We do not accept liability for any loss or damage, including without limitation, any loss of profit that may arise directly or indirectly from the use of or reliance on such information.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>5. Platform Availability</h3>
            <p>We do not guarantee that the platform, or any content on it, will always be available or be uninterrupted. We may suspend, withdraw, discontinue, or change all or any part of the platform without notice. We will not be liable to you if for any reason the platform is unavailable at any time or for any period.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>6. Technical Risks</h3>
            <p>Digital asset trading involves various technical risks, including but not limited to:</p>
            <ul>
              <li>Blockchain network delays or congestion</li>
              <li>Software bugs or errors</li>
              <li>Internet connectivity issues</li>
              <li>Hardware failures</li>
              <li>Security breaches by hackers</li>
              <li>Fork or rollback of blockchains</li>
            </ul>
            <p>We shall not be responsible for any loss or damage caused by these technical issues.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>7. Regulatory Risks</h3>
            <p>The regulatory status of digital assets and blockchain technology is unclear or unsettled in many jurisdictions. Changes in regulations may adversely affect the value of digital assets and the operation of blockchain networks.</p>
            <p>You are responsible for complying with all applicable laws and regulations in your jurisdiction. We do not guarantee that our services comply with the laws and regulations of any particular jurisdiction outside of the ones we explicitly state.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>8. Tax Considerations</h3>
            <p>Trading or holding digital assets may have tax implications in your jurisdiction. You are solely responsible for determining whether and what taxes apply to your digital asset transactions. We are not responsible for determining whether taxes apply to your transactions or for collecting, reporting, withholding, or remitting any taxes arising from any digital asset transactions.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>9. Third-Party Links</h3>
            <p>The platform may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that we shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>10. Changes to This Disclaimer</h3>
            <p>We reserve the right to modify this disclaimer at any time. If we make material changes to this disclaimer, we will notify you by posting the new disclaimer on the platform and updating the "Last Updated" date at the top of this disclaimer.</p>
          </div>
          
          <div class="disclaimer-item">
            <h3>11. Contact Us</h3>
            <p>If you have any questions about this disclaimer, please contact us</p>
          </div>
        </div>
      `
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>
<style scoped>
.disclaimer-content {
  padding: 15px;
  color: #333;
  line-height: 1.6;
}

.disclaimer-section {
  max-width: 800px;
  margin: 0 auto;
}

.disclaimer-section h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.last-updated {
  color: #666;
  font-style: italic;
  margin-bottom: 20px;
}

.disclaimer-item {
  margin-bottom: 25px;
}

.disclaimer-item h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #0d47a1;
}

.disclaimer-item p {
  margin-bottom: 10px;
}

.disclaimer-item ul {
  padding-left: 20px;
  margin-bottom: 10px;
}

.disclaimer-item li {
  margin-bottom: 5px;
}
</style>